import React from "react";
import { Link } from "react-router-dom";
import { Mail, Heart, Facebook, BookOpen } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_e1e47677-df71-49c4-917c-4fa0a875df63/artifacts/mtdbnete_Untitled%20design%20-%202026-01-07T124500.690.png";
const MISSOURI_HOSPICE_BADGE = "https://customer-assets.emergentagent.com/job_8c335a57-f1ab-4e57-a235-507f65edfbc5/artifacts/dfuck8i4_bb387419-a616-466d-a17d-80f99efca60d.jpg";
const NEDA_BADGE = "https://customer-assets.emergentagent.com/job_8c335a57-f1ab-4e57-a235-507f65edfbc5/artifacts/tzebl7sx_d017ed0d-b4ff-495a-86b0-8e8164ac6451.jpg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-rose-50 to-rose-100" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

          {/* Logo and Tagline */}
          <div className="flex flex-col items-center md:items-start">
            <img
              src={LOGO_URL}
              alt="Serenity Passage - End-of-Life Doula in Columbia, MO"
              className="h-20 w-auto object-contain mb-4"
              data-testid="footer-logo"
            />
            <p className="text-gray-700 text-center md:text-left font-medium">
              Serenity Passage
            </p>
            <p className="text-gray-600 text-sm text-center md:text-left mt-1">
              End-of-Life Doula in Columbia, MO
            </p>
            <p className="text-gray-600 text-sm text-center md:text-left">
              Compassionate Support for Life&apos;s Final Journey
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-gray-800 font-semibold mb-4">Quick Links</h3>
            <nav className="flex flex-col space-y-2" aria-label="Footer navigation">
              <Link to="/" className="text-gray-600 hover:text-rose-600 transition-colors text-sm">Home</Link>
              <Link to="/about" className="text-gray-600 hover:text-rose-600 transition-colors text-sm">About Monica</Link>
              <Link to="/services" className="text-gray-600 hover:text-rose-600 transition-colors text-sm">Services</Link>
              <Link to="/faq" className="text-gray-600 hover:text-rose-600 transition-colors text-sm">FAQ</Link>
              <Link to="/contact" className="text-gray-600 hover:text-rose-600 transition-colors text-sm">Contact</Link>
              <Link to="/privacy-policy" className="text-gray-600 hover:text-rose-600 transition-colors text-sm">Privacy Policy</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-gray-800 font-semibold mb-4">Get in Touch</h3>

            <div className="flex flex-col space-y-3">

              {/* Email */}
              <a
                href="mailto:mokorba@gmail.com"
                className="flex items-center gap-2 text-gray-600 hover:text-rose-600 transition-colors text-sm"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4" />
                mokorba@gmail.com
              </a>

              {/* 👉 NEW — FACEBOOK LINK */}
              <a
                href="https://www.facebook.com/profile.php?id=61584651780968"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors text-sm"
              >
                <Facebook className="w-4 h-4" />
                Follow on Facebook
              </a>

              {/* Substack Link */}
              <a
                href="https://substack.com/@monicawrites"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-600 hover:text-orange-600 transition-colors text-sm"
                data-testid="footer-substack"
              >
                <BookOpen className="w-4 h-4" />
                Read my Substack
              </a>

              <p className="text-gray-500 text-xs mt-4">
                Serving Columbia, MO & Mid-Missouri with compassionate end-of-life doula services
              </p>
            </div>
          </div>

          {/* Organization Badges */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-gray-800 font-semibold mb-4">Member Of</h3>
            <div className="flex flex-wrap justify-center md:justify-start gap-3">
              <img
                src={MISSOURI_HOSPICE_BADGE}
                alt="Missouri Hospice & Palliative Care Association Member"
                className="h-16 w-auto object-contain rounded"
                data-testid="footer-missouri-hospice-badge"
              />
              <img
                src={NEDA_BADGE}
                alt="NEDA - National End-of-Life Doula Alliance Member"
                className="h-16 w-auto object-contain rounded"
                data-testid="footer-neda-badge"
              />
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10 pt-6 border-t border-rose-200">
          <p className="text-center text-gray-500 text-sm">
            © {currentYear} Serenity Passage. All rights reserved.
          </p>
          <p className="text-center text-gray-400 text-xs mt-2 flex items-center justify-center gap-1">
            <Heart className="w-3 h-3 text-rose-400" />
            End-of-Life Doula Services in Columbia, Missouri & Mid-Missouri
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;   // 👉 (keep/export)

